import { useWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import { useEventInfo } from '@shared/utils/eventInfo';
import React from 'react';
import { HeaderV2Props, HeaderV2 } from '../HeaderV2';
import { Header } from '../Header';

export interface WebsiteHeaderProps extends Omit<HeaderV2Props, 'websiteHeader'> {
  isNativeAccommodations: boolean;
  pageId?: string;
}

const WebsiteHeader = ({ isNativeAccommodations, pageType, eventDisplayName, pageId, ...restProps }: WebsiteHeaderProps) => {
  const { eventHandle } = useEventInfo();
  const { websiteHeader } = useWebsiteHeaderSettings({
    eventHandle: eventHandle ?? '',
    targetWebsiteLayout: 'brannan'
  });

  if (!isNativeAccommodations) {
    return websiteHeader ? (
      <>
        <HeaderV2 {...restProps} eventDisplayName={websiteHeader.eventDisplayName} websiteHeader={websiteHeader} pageType={pageType} pageId={pageId} />
      </>
    ) : (
      <Header {...restProps} eventDisplayName={eventDisplayName} />
    );
  }
  return null;
};

export default WebsiteHeader;
